import { getEnvVar } from '@utils/environmentVariables';

export const baseApiUrl =
  getEnvVar('NEXT_PUBLIC_STAGE') === undefined || getEnvVar('NEXT_PUBLIC_STAGE') === ''
    ? 'https://api.spm-dev.com'
    : `https://api.spm-${getEnvVar('NEXT_PUBLIC_STAGE')}.com`;
